import { ActionContext } from 'vuex';
import { IWorkOrderState } from '@/store/work-order/workOrder.state';
import { UserApi, WorkOrderApi } from '@phrospr/api-backend';

export const workOrderActions = {
    async loadWorkOrderUsers(context: ActionContext<IWorkOrderState, IWorkOrderState>) {
        const { workOrderUsersLastSync } = context.state;
        if (
            workOrderUsersLastSync !== undefined &&
            workOrderUsersLastSync.getTime() > new Date().getTime() - 1000 * 60 * 5 // 5 minutes ago
        )
            return;

        const users = (await UserApi.listUsers()).data.filter(user => !user.data.ignoreUserInCalendarList);
        context.commit('setWorkOrderUsers', users);
    },

    async loadWorkOrderTypes(context: ActionContext<IWorkOrderState, IWorkOrderState>) {
        const { workOrderTypesLastSync } = context.state;
        if (
            workOrderTypesLastSync !== undefined &&
            workOrderTypesLastSync.getTime() > new Date().getTime() - 1000 * 60 * 5 // 5 minutes ago
        )
            return;

        // Inactive ones included: a work order saved on a since-deactivated type must still
        // show it; the pickers decide what to offer (selectableTypes).
        const types = (await WorkOrderApi.getWorkOrderTypes(true)).data;
        context.commit('setWorkOrderTypes', types);
    },

    async loadWorkOrderChecklists(context: ActionContext<IWorkOrderState, IWorkOrderState>) {
        const { workOrderChecklistsLastSync } = context.state;
        if (
            workOrderChecklistsLastSync !== undefined &&
            workOrderChecklistsLastSync.getTime() > new Date().getTime() - 1000 * 60 * 5 // 5 minutes ago
        )
            return;

        const checklists = (await WorkOrderApi.getWorkOrderChecklists()).data;
        context.commit('setWorkOrderChecklists', checklists);
    },

    async startWorkOrderUpsert(context: ActionContext<IWorkOrderState, IWorkOrderState>, workOrderId?: number) {
        if (context.state.isCachedUpsertWorkOrder === true) {
            context.commit('removeCacheWorkOrder');
            if (context.state.upsertWorkOrder !== undefined) return;
        }
        context.commit('resetWorkOrder');
        if (workOrderId === undefined) return context.commit('createNewWorkOrder');
        const workOrder = (await WorkOrderApi.getWorkOrder(workOrderId)).data;
        context.commit('updateWorkOrder', workOrder);
        context.commit('setSelectedClient', workOrder.client);
    },
};
